import EventManager from "../manager/event_manager";
import AppData from '../pacakge/public/const/app_data';
import Utility from "../utility/utility";

const { ccclass, menu, property, executeInEditMode, inspector, requireComponent } = cc._decorator;

@ccclass("UIItemOptimizeDCOptionsByPath")
export class UIItemOptimizeDCOptionsByPath {
    @property(cc.String)
    nodePath: string = '';

    /**
     * 待优化节点的路径，层级使用斜线分隔
     * 例如：nodeNameA/nodeNameB/nodeNameC
     */
    @property({
        type: cc.Node,
        displayName: '层级节点',
    })
    nodeParent: cc.Node = null

    srcPos: cc.Vec2 = null
    srcParent: cc.Node = null
    srcScale: number = null
    isDirty: boolean = false
    isParentHide: boolean = false
    node: cc.Node = null
}

@ccclass
@menu('custom/UIItemOptimizeDCByPath')
export default class UIItemOptimizeDCByPath extends cc.Component {

    @property([cc.Node])
    tirggleNodes: cc.Node[] = []

    @property([UIItemOptimizeDCOptionsByPath])
    options: UIItemOptimizeDCOptionsByPath[] = []

    @property(cc.Node)
    nodeHide: cc.Node = null

    protected m_children: cc.Node[] = []
    protected m_inited: boolean = false
    odcs: UIItemOptimizeDCByPath[] = []
    protected m_isDirty: boolean = false

    protected init(){
        if(!this.m_inited){
            this.m_inited = true
            let ops = this.options
            this.node.on(cc.Node.EventType.POSITION_CHANGED, this.on_position_changed, this)  
            this.node.on(cc.Node.EventType.CHILD_ADDED, this.on_child_count_change, this)
            for (let index = 0; index < ops.length; index++) {
                const op = ops[index];
                if(!op.node && op.nodePath && op.nodePath != ''){
                    op.node = Utility.findChildNode(this.node, op.nodePath)
                }
                if(op.node && op.node.parent != this.node){
                    ops.splice(index, 1)
                    index--
                    let odc = op.node.parent.getComponent(UIItemOptimizeDCByPath)
                    if(!odc){
                        odc = op.node.parent.addComponent(UIItemOptimizeDCByPath)
                    }
                    odc.options.push(op)
                    this.addOptimizeDC(this, odc)
                }
            }
            this.node.on('active-in-hierarchy-changed', this.on_active_in_hierarchy_changed, this);            
        }    
    }    

    protected on_child_count_change(){
        let ops = this.options
        for (let index = 0; index < ops.length; index++) {
            const op = ops[index];
            if(!op.node && op.nodePath && op.nodePath != ''){
                op.node = Utility.findChildNode(this.node, op.nodePath)
                this.m_isDirty = true
            }
        }
    }

    protected addOptimizeDC(srcOdc: UIItemOptimizeDCByPath, odc: UIItemOptimizeDCByPath){
        if(true || srcOdc.node == odc.node.parent){
            srcOdc.odcs.push(odc)
            return
        }
        let parentOdc = odc.node.parent.getComponent(UIItemOptimizeDCByPath)
        if(!parentOdc){
            parentOdc = odc.node.parent.addComponent(UIItemOptimizeDCByPath)
        }
        parentOdc.odcs.push(odc)
        this.addOptimizeDC(srcOdc, parentOdc)
    }

    protected optimizeNodes(){
        if(!this.m_isDirty){
            return
        }
        this.m_isDirty = false
        let ops = this.options
        for (let index = 0; index < ops.length; index++) {
            const op = ops[index];
            if(!op.node || !op.nodeParent){
                continue
            }

            !op.srcScale && (op.srcScale = op.node.scale * op.node.parent.scale)
            !op.srcPos && (op.srcPos = op.node.position.clone())
            !op.srcParent && (op.srcParent = op.node.parent)  
            if(op.isDirty){
                if(op.isParentHide){
                    op.node.removeFromParent()
                    // op.node.setParent(op.srcParent)  
                }else{
                    op.node.setParent(op.nodeParent)
                    op.node.position = op.nodeParent.convertToNodeSpaceAR(op.srcParent.convertToWorldSpaceAR(op.srcPos))
                    op.node.scale = op.srcScale / op.nodeParent.scale
                }      
                op.isDirty = false          
            }                      
        }
        this.scheduleOnce(()=>{
            this.on_position_changed()
        }, 0)
    }

    protected showNodes(show: boolean){
        this.m_isDirty = true
        for (let index = 0; index < this.options.length; index++) {
            const element = this.options[index];
            element.isParentHide = !show
            element.isDirty = true
        }
    }


    on_active_in_hierarchy_changed(node: cc.Node){
        // if(this.node.activeInHierarchy){
        //     this.init()    
        // }else{
        //     this.collectNodes()
        // }
    }

    on_enable(){
        this.init()     
        for (let index = 0; index < this.tirggleNodes.length; index++) {
            const node = this.tirggleNodes[index];
            node.on(cc.Node.EventType.POSITION_CHANGED, this.on_position_changed, this)  
        }           
        this.showNodes(true)
        for (let index = 0; index < this.odcs.length; index++) {
            const element = this.odcs[index];
            element.on_enable()
        }
    }

    on_disable(){
        this.showNodes(false)
        for (let index = 0; index < this.tirggleNodes.length; index++) {
            const node = this.tirggleNodes[index];
            node.off(cc.Node.EventType.POSITION_CHANGED, this.on_position_changed, this)  
        }
        for (let index = 0; index < this.odcs.length; index++) {
            const element = this.odcs[index];
            element.on_disable()
        }
        this.doOptimize()
    }

    onEnable(){

        this.on_enable()
    }

    onDisable(){  
        this.on_disable()
    }

    update(dt){
        this.doOptimize()
    }

    doOptimize(){
        if(this.m_isDirty){
            this.optimizeNodes()
        }
    }

    on_position_changed(){
        this.unscheduleAllCallbacks()
        let ops = this.options
        for (let index = 0; index < ops.length; index++) {
            const op = ops[index];
            if(!op.node || !op.nodeParent || !op.srcParent){
                continue
            }
            let pos = op.srcParent.convertToWorldSpaceAR(op.srcPos)
            pos = op.nodeParent.convertToNodeSpaceAR(pos)
            op.node.position = pos            
        }   
        for (let index = 0; index < this.odcs.length; index++) {
            const element = this.odcs[index];
            element.on_position_changed()
        }    
    }

}